import { FC, ReactNode } from 'react';
import { ChevronRight } from '@ixigo/icons';
import Typography from '@ixigo/iui/Typography';

interface ActionItemProps {
    icon: ReactNode;
    title: string;
    description: string;
    onClick: () => void;
    showBorder?: boolean;
    iconContainerClassName?: string;
}

const ActionItem: FC<ActionItemProps> = ({
    icon,
    title,
    description,
    onClick,
    showBorder = false,
    iconContainerClassName = '',
}) => (
    <button
        onClick={onClick}
        className='w-full flex items-center px-20 h-[72px] hover:bg-charcoal-50 transition-colors relative'
        type='button'
    >
        {showBorder && <div className='absolute left-0 right-0 bottom-0 mx-20 border-b border-charcoal-100' />}
        <div
            className={`w-40 h-40 rounded-full flex items-center justify-center flex-shrink-0 ${iconContainerClassName}`}
        >
            {icon}
        </div>
        <div className='flex-1 ml-15 text-left'>
            <Typography variant='body-md' className='text-charcoal-800 font-normal'>
                {title}
            </Typography>
            <Typography variant='body-sm' className='text-charcoal-600'>
                {description}
            </Typography>
        </div>
        <ChevronRight className='text-charcoal-600 ml-10' width={24} height={24} />
    </button>
);

export default ActionItem;
